var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-container"},[_c('div',{staticClass:"bg"},[_c('div',{staticClass:"title"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n      ")]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }